import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApiUrl } from '../utility/api-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
// tslint:disable-next-line: jsdoc-format
/**Api service call for Crewbid App */
export class CrewbidApiService {
  constructor(private http: HttpClient) {}

  /**
   * @method GetRestDataForGet get request
   * @param serviceNameandParameter (Service name and parameter as string)
   */

  public GetRestDataForGet(serviceNameandParameter: string): Observable<any> {
    return this.http.get<any>(ApiUrl + serviceNameandParameter, {
      withCredentials: true,
    });
  }

  /**
   * @method GetRestDataForPost post request
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */

  public GetRestDataForPost(
    serviceNameandParameter: string,
    jsonString: any
  ): Observable<any> {
    return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
      withCredentials: true,
    });
  }

  /**
   * @method AsyncGetRestDataForPost async post request
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */
  public async AsyncGetRestDataForPost(
    serviceNameandParameter: string,
    jsonString: any
  ): Promise<any> {
    const rsp = await this.http
      .post<any>(ApiUrl + serviceNameandParameter, jsonString, {
        withCredentials: true,
      })
      .toPromise();
    return rsp;
  }

  public paypalPayment(
    serviceNameandParameter: string,
    jsonString: any
  ): Observable<any> {
      const ApiUrl = 'https://www.qa.crewbid-wbidmax.com/PayPalWebHook/';
      return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
      responseType: 'json',
    });
  }

  public stripePayment(
    serviceNameandParameter: string,
    jsonString: any
  ): Observable<any> {
      const ApiUrl = 'https://www.qa.crewbid-wbidmax.com/StripeWebHook/';
      return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
      responseType: 'json',
    });
  }

    /**
   * @method GetStripePaymentStatus for fetching the vacation data
   * @returns status as string
   */
    public GetStripePaymentStatus(invoiceId: string): Observable<any> {
          const ApiUrl = 'https://www.qa.crewbid-wbidmax.com/StripeWebHook/api/StripePayWebHook/GetStripePaymentStatus?invoiceId=' + invoiceId;
          return this.http.get<any>(ApiUrl, {
          responseType: 'text' as 'json',
        });
    }
}
